import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";


export default class YesNoQuestionStep extends React.Component {
    render() {
        return <Fragment>
            <StepQuestion>
                {(this.props.questionText) || "?"}
            </StepQuestion>
            <StepButton
                onClick={this.props.onYesClick}
            >
                {this.props.yesText || "Yes"}
            </StepButton>
            <StepButton
                onClick={this.props.onNoClick}
            >
                {this.props.noText || "No"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </Fragment>
    }
}